@if (hasChecks) {
<forge-card class="no-padding">
    <forge-toolbar>
        <h2 class="forge-typography--heading4" slot="start">In Balance</h2>
        @if (hasSettings) {
        <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0" aria-haspopup="true"
            telemetry="Settings" aria-label="settings">
            <forge-tooltip>Settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
        }
    </forge-toolbar>
    @if (loaded) {
    <div>
        @for (provider of providers; track provider; let i = $index) {
        <div>
            <in-balance-check [provider]="provider" [criteria]="chartCriteria"></in-balance-check>
        </div>
        }
    </div>
    }
</forge-card>
}